/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface Campaign {
  type?: string;
  id?: string;
  attributes?: {
    id: number;
    identifier: string | null;
    conversion?: number | null;
    cpi: string | null;
    length_of_interview?: number | null;
    name: string | null;
    total_remaining: number | null;
    status: number | null;
    providable_id?: number | null;
    providable_type?: string | null;
    created_at?: string | null;
    adjusted_cpi: string | null;
    customer_id: number | null;
    incidence?: number | null;
    pre_flight_date?: string | null;
    reentry_interval?: number | null;
    country_id: number | null;
    language_id: number | null;
    priority?: number | null;
    project_id: number | null;
    wave_number?: number | null;
    launch_date?: string | null;
    original_quotas_total?: number | null;
    relationships?: { project?: Project; campaign_quotas?: CampaignQuota };
  };
}

export interface CampaignQuota {
  type: string;
  id: string;
  attributes?: {
    id: number;
    identifier: string | null;
    num_respondents: number | null;
    quotaable_id?: number | null;
    quotaable_type?: string | null;
    created_at?: string | null;
    updated_at?: string | null;
    is_global?: boolean | null;
    name?: string | null;
    feasibility_json?: string | null;
    is_click_balanced?: boolean;
    quota_total: number | null;
  };
}

export interface Project {
  type?: string;
  id?: string;
  attributes?: {
    name?: string | null;
    created_at?: string | null;
    status?: number | null;
    identifier?: string | null;
    user_id?: number | null;
    access_level?: number | null;
    campaign_identifier?: string | null;
    is_recurring?: boolean;
    is_managed?: boolean;
    active_campaign_completes_count?: number | null;
    active_campaign_total_remaining?: number | null;
    total_waves?: number | null;
    waves_remaining?: number | null;
    completed_waves_count?: number | null;
    creator_name?: string | null;
  };
}

export interface Qualification {
  type?: string;
  id?: string;
  attributes?: {
    id: number;
    name?: string | null;
    question_text?: string | null;
    question_id?: number | null;
    answer_type?: number | null;
    designation?: number | null;
    custom_qualification_answers?: {
      id?: number;
      attributes?: {
        option_text?: string;
        pre_code?: number;
        value?: any[] | null;
      };
    }[];
  };
  relationships?: { qualification_answers?: { data?: QualificationAnswer[] } };
}

export interface QualificationAnswer {
  type?: string;
  id?: string;
  attributes?: {
    id: number;
    option_text?: string | null;
    en_translation?: string | null;
    pre_code?: string | null;
    order_priority?: number | null;
  };
}

export interface CampaignQualification {
  type: string;
  id: string;
  attributes?: {
    id: number;
    is_census_balanced?: boolean | null;
    pre_code_values?: string | null;
    qualification_id?: number | null;
    question_id?: number | null;
    identifier?: string | null;
    targeting?: {
      pre_code?: string | null;
      option_text?: string | null;
      en_translation?: string | null;
    }[];
  };
}

export interface ProjectReview {
  type?: string;
  id?: string;
  attributes?: {
    overview: {
      respondents: { remaining: number | null; collected: number };
      num_questions: { total: number; total_for_cpi: number };
    };
    financials: {
      account_balance: {
        funds_total: number;
        funds_available: number;
        active_campaigns_cost: number;
      };
      campaign_cost: { total: number; amount_due: number };
      cpi: number;
      cost_per_question: number;
      customer_type: number;
    };
    errors: string[];
    can_checkout: boolean;
    is_launchable: boolean;
  };
}

export interface PaymentMethod {
  type?: string;
  id?: string;
  attributes?: {
    customer_id: number | null;
    stripe_payment_identifier: string | null;
    brand: string | null;
    exp_month: number | null;
    exp_year: number | null;
    funding: string | null;
    last4: string | null;
    name: string | null;
    payment_method_type: number | null;
  };
}

export interface ProjectStatusCount {
  type?: string;
  id?: string;
  attributes?: { label: string; status: string; count: number };
}

export interface TapQuestion {
  type?: string;
  id?: string;
  attributes?: {
    id: number;
    identifier?: string | null;
    tap_survey_id?: number;
    question_text?: string | null;
    position?: number | null;
    image?: { url?: string | null; thumb?: { url?: string | null } };
    tap_answer_type?: number | null;
    randomize_answers?: boolean | null;
    allows_multiple_selection?: boolean | null;
    is_answer_optional?: boolean | null;
    root_tap_question_id?: number | null;
    scale_range?: number | null;
  };
}

export interface TapAnswer {
  type?: string;
  id?: string;
  attributes?: {
    id: number;
    identifier?: string | null;
    tap_question_id?: number;
    option_text?: string | null;
    position?: number | null;
    image?: { url?: string | null; thumb?: { url?: string | null } };
    option_type?: number | null;
    root_tap_answer_id?: number | null;
  };
}

export interface LongitudinalQuestionResult {
  type?: string;
  id?: string;
  meta?: Record<string, any> | null;
  attributes?: {
    tap_question_id?: number;
    results?: Record<
      string,
      null | { tap_survey_id?: number; value?: number; percentage?: number }[]
    >;
  };
}

export interface TapQuestionScale {
  type?: string;
  id?: string;
  attributes?: {
    id: number;
    tap_question_id?: number;
    scale_size?: number | null;
    beginning_label?: string | null;
    end_label?: string | null;
  };
}

export interface TapQuestionResult {
  type?: string;
  id?: string;
  attributes?: {
    tap_question_id?: number;
    results?: {
      total_respondents?: number | null;
      other_answers?: string[] | null;
      free_text_answers?: string[] | null;
      answers?: Record<
        string,
        null | {
          total?: number | null;
          percentage?: number | null;
          ranks?: number[];
          average_rank?: number | null;
        }
      >;
    };
  };
}

export interface TapQuestionCrossTabResult {
  type?: string;
  id?: string;
  attributes?: {
    tap_question_id?: number;
    results?: {
      labels?: string[];
      answers?: Record<
        string,
        null | {
          total?: number | null;
          percentage?: number | null;
          ranks?: number[];
          average_rank?: number | null;
        }
      >;
    };
  };
}

export interface QualificationAnswerLabel {
  type?: string;
  id?: string;
  attributes?: { key?: string; label?: string };
}

export type InsightsApi = any;

export interface CampaignCountryLanguageUpdate {
  country_id?: string;
  language_id?: string;
}

export interface Language {
  id?: string;
  name?: string;
  abbr?: string;
}

export interface Country {
  id?: number;
  name?: string;
  abbr?: string;
  languages?: Language[];
}

export interface ErrorResponse {
  response?: { data?: { error?: string } };
}

export interface ProjectsListParams {
  page?: string;
  project_type?: string;
}

export interface CampaignQualificationsListParams {
  qualifiable_identifier: string;
}

export interface LongitudinalTapQuestionsQuestionResultsDetailParams {
  tap_survey_ids?: string[];
  filters?: object;
  group_rc_answers?: boolean;
  identifier: string;
}

export interface ProjectsRootQuestionsListDetailParams {
  tap_survey_ids?: string[];
  identifier: string;
}

export interface ProjectsWavesDetailParams {
  limit?: number;
  identifier: string;
}

export interface QualificationAnswerLabelsListParams {
  question_id: string;
  country_id: string;
  language_id: string;
  result_identifier?: string;
}

export interface QualificationsListParams {
  country_id: string;
  language_id: string;
  profiling_only?: number;
}

export interface TapQuestionsTapAnswersListDetailParams {
  result_identifier?: string;
  identifier: string;
}

export interface TapQuestionsCrossTabResultsDetailParams {
  result_identifier?: string;
  filters?: object;
  cross_tab_question_id?: string;
  group_answers?: boolean;
  identifier: string;
}

export interface TapQuestionsResultsDetailParams {
  filters?: object;
  group_answers?: boolean;
  identifier: string;
}

export interface TapSurveysQuestionsListDetailParams {
  result_identifier?: string;
  identifier: string;
}

export namespace InsightsApi {
  /**
   * No description
   * @tags insights_api/campaign_columns
   * @name ProjectsCampaignsColumnsDetail
   * @summary Retrieves the csv header column mapping for a campaign
   * @request GET:/insights_api/projects/{project_id}/campaigns/{id}/columns
   * @secure
   * @response `200` `InsightsApi` returns the correct columns hash
   * @response `401` `void` unauthorized
   */
  export namespace ProjectsCampaignsColumnsDetail {
    export type RequestParams = { projectId: string; id: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = InsightsApi;
  }
  /**
   * No description
   * @tags insights_api/campaign_csv
   * @name ProjectsCampaignsDetail
   * @summary Retrieves a campaign result CSV
   * @request GET:/insights_api/projects/{project_id}/campaigns/{id}
   * @secure
   * @response `200` `void` returns a CSV file
   * @response `401` `void` unauthorized
   */
  export namespace ProjectsCampaignsDetail {
    export type RequestParams = { projectId: string; id: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
  /**
   * No description
   * @tags insights_api/projects_list
   * @name ProjectsList
   * @summary Retrieves a list of projects
   * @request GET:/insights_api/projects
   * @secure
   * @response `200` `InsightsApi` returns the filtered projects_list resource
   * @response `401` `void` unauthorized
   */
  export namespace ProjectsList {
    export type RequestParams = {};
    export type RequestQuery = { page?: string; project_type?: string };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = InsightsApi;
  }
  /**
   * No description
   * @tags api/projects_show
   * @name ProjectsDetail
   * @summary Retrieve a single project
   * @request GET:/insights_api/projects/{id}
   * @secure
   * @response `200` `InsightsApi` returns a valid project resource
   * @response `401` `void` unauthorized
   */
  export namespace ProjectsDetail {
    export type RequestParams = { id: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = InsightsApi;
  }
}

export namespace InsightsPlatform {
  /**
   * No description
   * @tags campaigns
   * @name CampaignsLaunchUpdate
   * @summary Launch a project
   * @request PUT:/insights_platform/campaigns/{id}/launch
   * @secure
   * @response `200` `void` launch a campaign
   * @response `401` `void` Unauthorized
   * @response `422` `void` Invalid Identifier
   */
  export namespace CampaignsLaunchUpdate {
    export type RequestParams = { id: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
  /**
   * No description
   * @tags campaign_qualifications
   * @name CampaignQualificationsList
   * @summary Retrieves campaign qualifications belonging to a campaign quota
   * @request GET:/insights_platform/campaign_qualifications
   * @secure
   * @response `200` `{ data?: ((CampaignQualification))[] }` campaign_qualification found
   */
  export namespace CampaignQualificationsList {
    export type RequestParams = {};
    export type RequestQuery = { qualifiable_identifier: string };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = { data?: CampaignQualification[] };
  }
  /**
   * No description
   * @tags update_country_language
   * @name CampaignsUpdateCountryLanguagePartialUpdate
   * @summary Updates the country/language of a campaign
   * @request PATCH:/insights_platform/campaigns/{id}/update_country_language
   * @secure
   * @response `200` `void` Country/language update successful
   * @response `401` `void` Unauthorized
   * @response `422` `void` Invalid Identifier
   */
  export namespace CampaignsUpdateCountryLanguagePartialUpdate {
    export type RequestParams = { id: string };
    export type RequestQuery = {};
    export type RequestBody = CampaignCountryLanguageUpdate;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
  /**
   * No description
   * @tags longitudinal_question_result
   * @name LongitudinalTapQuestionsQuestionResultsDetail
   * @summary Retrieves the longitudinal question result
   * @request GET:/insights_platform/longitudinal/tap_questions/{identifier}/question-results
   * @secure
   * @response `200` `{ data?: LongitudinalQuestionResult }` authorized
   * @response `401` `void` unauthorized
   */
  export namespace LongitudinalTapQuestionsQuestionResultsDetail {
    export type RequestParams = { identifier: string };
    export type RequestQuery = {
      tap_survey_ids?: string[];
      filters?: object;
      group_rc_answers?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = { data?: LongitudinalQuestionResult };
  }
  /**
   * No description
   * @tags root_questions_list
   * @name ProjectsRootQuestionsListDetail
   * @summary Retrieves a list of questions
   * @request GET:/insights_platform/projects/{identifier}/root-questions-list
   * @secure
   * @response `200` `{ data?: ((TapQuestion))[] }` authorized
   * @response `401` `void` unauthorized
   */
  export namespace ProjectsRootQuestionsListDetail {
    export type RequestParams = { identifier: string };
    export type RequestQuery = { tap_survey_ids?: string[] };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = { data?: TapQuestion[] };
  }
  /**
   * No description
   * @tags root_tap_answers_list
   * @name LongitudinalTapQuestionsRootTapAnswersListDetail
   * @summary Retrieves all root tap answers for a given root tap question ID
   * @request GET:/insights_platform/longitudinal/tap_questions/{identifier}/root-tap-answers-list
   * @secure
   * @response `200` `{ data?: ((TapAnswer))[] }` authorized
   * @response `401` `void` unauthorized
   */
  export namespace LongitudinalTapQuestionsRootTapAnswersListDetail {
    export type RequestParams = { identifier: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = { data?: TapAnswer[] };
  }
  /**
   * No description
   * @tags payment_methods
   * @name CustomersPaymentMethodsDetail
   * @summary Retrieves a collection of payment methods
   * @request GET:/insights_platform/customers/{identifier}/payment_methods
   * @secure
   * @response `200` `{ data?: ((PaymentMethod))[] }` authorized
   * @response `401` `void` unauthorized
   */
  export namespace CustomersPaymentMethodsDetail {
    export type RequestParams = { identifier: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = { data?: PaymentMethod[] };
  }
  /**
   * No description
   * @tags project_review
   * @name ProjectsReviewDetail
   * @summary Retrieves a project review object
   * @request GET:/insights_platform/projects/{identifier}/review
   * @secure
   * @response `200` `{ data?: ProjectReview }` project review found/authorized
   * @response `401` `void` user not authorized for project
   */
  export namespace ProjectsReviewDetail {
    export type RequestParams = { identifier: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = { data?: ProjectReview };
  }
  /**
   * No description
   * @tags projects
   * @name ProjectStatusCountsList
   * @summary Retrieves the count of projects by status
   * @request GET:/insights_platform/project_status_counts
   * @secure
   * @response `200` `{ data?: ((ProjectStatusCount))[] }` without filters applied returns the right counts
   */
  export namespace ProjectStatusCountsList {
    export type RequestParams = {
      projectType: string;
      date: string;
      userId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = { data?: ProjectStatusCount[] };
  }
  /**
   * No description
   * @tags project_waves
   * @name ProjectsWavesDetail
   * @summary Retrieves a collection of waves
   * @request GET:/insights_platform/projects/{identifier}/waves
   * @secure
   * @response `200` `{ data?: ((Campaign))[] }` authorized
   * @response `401` `void` unauthorized
   */
  export namespace ProjectsWavesDetail {
    export type RequestParams = { identifier: string };
    export type RequestQuery = { limit?: number };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = { data?: Campaign[] };
  }
  /**
   * No description
   * @tags projects
   * @name ProjectsDetail
   * @summary Retrieves a project
   * @request GET:/insights_platform/projects/{identifier}
   * @secure
   * @response `200` `{ data?: Project }` project found
   */
  export namespace ProjectsDetail {
    export type RequestParams = { identifier: string };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = { data?: Project };
  }
  /**
   * No description
   * @tags qualification_answer_labels
   * @name QualificationAnswerLabelsList
   * @summary Retrieves qualification answer labels/buckets by question_id + country_id + language_id
   * @request GET:/insights_platform/qualification-answer-labels
   * @secure
   * @response `200` `{ data?: ((QualificationAnswerLabel))[] }` get labels success
   */
  export namespace QualificationAnswerLabelsList {
    export type RequestParams = {};
    export type RequestQuery = {
      question_id: string;
      country_id: string;
      language_id: string;
      result_identifier?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = { data?: QualificationAnswerLabel[] };
  }
  /**
   * No description
   * @tags qualifications
   * @name QualificationsList
   * @summary Retrieves available qualifications by country and language
   * @request GET:/insights_platform/qualifications
   * @secure
   * @response `200` `{ data?: ((Qualification))[], included?: ((QualificationAnswer))[] }` profiling qualifications only
   */
  export namespace QualificationsList {
    export type RequestParams = {};
    export type RequestQuery = {
      country_id: string;
      language_id: string;
      profiling_only?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = {
      data?: Qualification[];
      included?: QualificationAnswer[];
    };
  }
  /**
   * No description
   * @tags qualifications
   * @name QualificationsDetail
   * @summary Retrieves a qualification
   * @request GET:/insights_platform/qualifications/{id}
   * @secure
   * @response `200` `{ data?: Qualification, included?: ((QualificationAnswer))[] }` qualification found
   */
  export namespace QualificationsDetail {
    export type RequestParams = { id: string; byQuestionId: boolean };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = {
      data?: Qualification;
      included?: QualificationAnswer[];
    };
  }
  /**
   * No description
   * @tags tap_answers_list
   * @name TapQuestionsTapAnswersListDetail
   * @summary Retrieves all tap answers for a given tap question
   * @request GET:/insights_platform/tap_questions/{identifier}/tap-answers-list
   * @secure
   * @response `200` `{ data?: ((TapAnswer))[] }` authorized
   * @response `401` `void` unauthorized
   */
  export namespace TapQuestionsTapAnswersListDetail {
    export type RequestParams = { identifier: string };
    export type RequestQuery = { result_identifier?: string };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = { data?: TapAnswer[] };
  }
  /**
   * No description
   * @tags tap_question_cross_tab_result
   * @name TapQuestionsCrossTabResultsDetail
   * @summary Retrieves the single survey tap question cross tab result
   * @request GET:/insights_platform/tap_questions/{identifier}/cross-tab-results
   * @secure
   * @response `200` `{ data?: TapQuestionCrossTabResult }` authorized
   * @response `401` `void` unauthorized
   */
  export namespace TapQuestionsCrossTabResultsDetail {
    export type RequestParams = { identifier: string };
    export type RequestQuery = {
      result_identifier?: string;
      filters?: object;
      cross_tab_question_id?: string;
      group_answers?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = { data?: TapQuestionCrossTabResult };
  }
  /**
   * No description
   * @tags tap_question_result
   * @name TapQuestionsResultsDetail
   * @summary Retrieves the single survey tap question result
   * @request GET:/insights_platform/tap_questions/{identifier}/results
   * @secure
   * @response `200` `{ data?: TapQuestionResult }` authorized
   * @response `401` `void` unauthorized
   */
  export namespace TapQuestionsResultsDetail {
    export type RequestParams = { identifier: string };
    export type RequestQuery = { filters?: object; group_answers?: boolean };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = { data?: TapQuestionResult };
  }
  /**
   * No description
   * @tags tap_survey_questions_list
   * @name TapSurveysQuestionsListDetail
   * @summary Retrieves a list of questions
   * @request GET:/insights_platform/tap_surveys/{identifier}/questions-list
   * @secure
   * @response `200` `{ data?: ((TapQuestion))[] }` authorized
   * @response `401` `void` unauthorized
   */
  export namespace TapSurveysQuestionsListDetail {
    export type RequestParams = { identifier: string };
    export type RequestQuery = { result_identifier?: string };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = { data?: TapQuestion[] };
  }
}

import axios, {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  ResponseType,
} from 'axios';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  'body' | 'method' | 'query' | 'path'
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || 'http://{defaultHost}',
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  private mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig
  ): AxiosRequestConfig {
    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.instance.defaults.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  private createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      formData.append(
        key,
        property instanceof Blob
          ? property
          : typeof property === 'object' && property !== null
          ? JSON.stringify(property)
          : `${property}`
      );
      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = (format && this.format) || void 0;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === 'object'
    ) {
      requestParams.headers.common = { Accept: '*/*' };
      requestParams.headers.post = {};
      requestParams.headers.put = {};

      body = this.createFormData(body as Record<string, unknown>);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(type && type !== ContentType.FormData
          ? { 'Content-Type': type }
          : {}),
        ...(requestParams.headers || {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title API V1
 * @version v1
 * @baseUrl http://{defaultHost}
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  insightsApi = {
    /**
     * No description
     *
     * @tags insights_api/campaign_columns
     * @name ProjectsCampaignsColumnsDetail
     * @summary Retrieves the csv header column mapping for a campaign
     * @request GET:/insights_api/projects/{project_id}/campaigns/{id}/columns
     * @secure
     * @response `200` `InsightsApi` returns the correct columns hash
     * @response `401` `void` unauthorized
     */
    projectsCampaignsColumnsDetail: (
      projectId: string,
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<InsightsApi, void>({
        path: `/insights_api/projects/${projectId}/campaigns/${id}/columns`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags insights_api/campaign_csv
     * @name ProjectsCampaignsDetail
     * @summary Retrieves a campaign result CSV
     * @request GET:/insights_api/projects/{project_id}/campaigns/{id}
     * @secure
     * @response `200` `void` returns a CSV file
     * @response `401` `void` unauthorized
     */
    projectsCampaignsDetail: (
      projectId: string,
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/insights_api/projects/${projectId}/campaigns/${id}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags insights_api/projects_list
     * @name ProjectsList
     * @summary Retrieves a list of projects
     * @request GET:/insights_api/projects
     * @secure
     * @response `200` `InsightsApi` returns the filtered projects_list resource
     * @response `401` `void` unauthorized
     */
    projectsList: (query: ProjectsListParams, params: RequestParams = {}) =>
      this.request<InsightsApi, void>({
        path: `/insights_api/projects`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags api/projects_show
     * @name ProjectsDetail
     * @summary Retrieve a single project
     * @request GET:/insights_api/projects/{id}
     * @secure
     * @response `200` `InsightsApi` returns a valid project resource
     * @response `401` `void` unauthorized
     */
    projectsDetail: (id: string, params: RequestParams = {}) =>
      this.request<InsightsApi, void>({
        path: `/insights_api/projects/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  insightsPlatform = {
    /**
     * No description
     *
     * @tags campaigns
     * @name CampaignsLaunchUpdate
     * @summary Launch a project
     * @request PUT:/insights_platform/campaigns/{id}/launch
     * @secure
     * @response `200` `void` launch a campaign
     * @response `401` `void` Unauthorized
     * @response `422` `void` Invalid Identifier
     */
    campaignsLaunchUpdate: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/insights_platform/campaigns/${id}/launch`,
        method: 'PUT',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags campaign_qualifications
     * @name CampaignQualificationsList
     * @summary Retrieves campaign qualifications belonging to a campaign quota
     * @request GET:/insights_platform/campaign_qualifications
     * @secure
     * @response `200` `{ data?: ((CampaignQualification))[] }` campaign_qualification found
     */
    campaignQualificationsList: (
      query: CampaignQualificationsListParams,
      params: RequestParams = {}
    ) =>
      this.request<{ data?: CampaignQualification[] }, any>({
        path: `/insights_platform/campaign_qualifications`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags update_country_language
     * @name CampaignsUpdateCountryLanguagePartialUpdate
     * @summary Updates the country/language of a campaign
     * @request PATCH:/insights_platform/campaigns/{id}/update_country_language
     * @secure
     * @response `200` `void` Country/language update successful
     * @response `401` `void` Unauthorized
     * @response `422` `void` Invalid Identifier
     */
    campaignsUpdateCountryLanguagePartialUpdate: (
      id: string,
      data: CampaignCountryLanguageUpdate,
      params: RequestParams = {}
    ) =>
      this.request<void, void>({
        path: `/insights_platform/campaigns/${id}/update_country_language`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags longitudinal_question_result
     * @name LongitudinalTapQuestionsQuestionResultsDetail
     * @summary Retrieves the longitudinal question result
     * @request GET:/insights_platform/longitudinal/tap_questions/{identifier}/question-results
     * @secure
     * @response `200` `{ data?: LongitudinalQuestionResult }` authorized
     * @response `401` `void` unauthorized
     */
    longitudinalTapQuestionsQuestionResultsDetail: (
      {
        identifier,
        ...query
      }: LongitudinalTapQuestionsQuestionResultsDetailParams,
      params: RequestParams = {}
    ) =>
      this.request<{ data?: LongitudinalQuestionResult }, void>({
        path: `/insights_platform/longitudinal/tap_questions/${identifier}/question-results`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags root_questions_list
     * @name ProjectsRootQuestionsListDetail
     * @summary Retrieves a list of questions
     * @request GET:/insights_platform/projects/{identifier}/root-questions-list
     * @secure
     * @response `200` `{ data?: ((TapQuestion))[] }` authorized
     * @response `401` `void` unauthorized
     */
    projectsRootQuestionsListDetail: (
      { identifier, ...query }: ProjectsRootQuestionsListDetailParams,
      params: RequestParams = {}
    ) =>
      this.request<{ data?: TapQuestion[] }, void>({
        path: `/insights_platform/projects/${identifier}/root-questions-list`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags root_tap_answers_list
     * @name LongitudinalTapQuestionsRootTapAnswersListDetail
     * @summary Retrieves all root tap answers for a given root tap question ID
     * @request GET:/insights_platform/longitudinal/tap_questions/{identifier}/root-tap-answers-list
     * @secure
     * @response `200` `{ data?: ((TapAnswer))[] }` authorized
     * @response `401` `void` unauthorized
     */
    longitudinalTapQuestionsRootTapAnswersListDetail: (
      identifier: string,
      params: RequestParams = {}
    ) =>
      this.request<{ data?: TapAnswer[] }, void>({
        path: `/insights_platform/longitudinal/tap_questions/${identifier}/root-tap-answers-list`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags payment_methods
     * @name CustomersPaymentMethodsDetail
     * @summary Retrieves a collection of payment methods
     * @request GET:/insights_platform/customers/{identifier}/payment_methods
     * @secure
     * @response `200` `{ data?: ((PaymentMethod))[] }` authorized
     * @response `401` `void` unauthorized
     */
    customersPaymentMethodsDetail: (
      identifier: string,
      params: RequestParams = {}
    ) =>
      this.request<{ data?: PaymentMethod[] }, void>({
        path: `/insights_platform/customers/${identifier}/payment_methods`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags project_review
     * @name ProjectsReviewDetail
     * @summary Retrieves a project review object
     * @request GET:/insights_platform/projects/{identifier}/review
     * @secure
     * @response `200` `{ data?: ProjectReview }` project review found/authorized
     * @response `401` `void` user not authorized for project
     */
    projectsReviewDetail: (identifier: string, params: RequestParams = {}) =>
      this.request<{ data?: ProjectReview }, void>({
        path: `/insights_platform/projects/${identifier}/review`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags projects
     * @name ProjectStatusCountsList
     * @summary Retrieves the count of projects by status
     * @request GET:/insights_platform/project_status_counts
     * @secure
     * @response `200` `{ data?: ((ProjectStatusCount))[] }` without filters applied returns the right counts
     */
    projectStatusCountsList: (
      projectType: string,
      date: string,
      userId: string,
      params: RequestParams = {}
    ) =>
      this.request<{ data?: ProjectStatusCount[] }, any>({
        path: `/insights_platform/project_status_counts`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags project_waves
     * @name ProjectsWavesDetail
     * @summary Retrieves a collection of waves
     * @request GET:/insights_platform/projects/{identifier}/waves
     * @secure
     * @response `200` `{ data?: ((Campaign))[] }` authorized
     * @response `401` `void` unauthorized
     */
    projectsWavesDetail: (
      { identifier, ...query }: ProjectsWavesDetailParams,
      params: RequestParams = {}
    ) =>
      this.request<{ data?: Campaign[] }, void>({
        path: `/insights_platform/projects/${identifier}/waves`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags projects
     * @name ProjectsDetail
     * @summary Retrieves a project
     * @request GET:/insights_platform/projects/{identifier}
     * @secure
     * @response `200` `{ data?: Project }` project found
     */
    projectsDetail: (identifier: string, params: RequestParams = {}) =>
      this.request<{ data?: Project }, any>({
        path: `/insights_platform/projects/${identifier}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags qualification_answer_labels
     * @name QualificationAnswerLabelsList
     * @summary Retrieves qualification answer labels/buckets by question_id + country_id + language_id
     * @request GET:/insights_platform/qualification-answer-labels
     * @secure
     * @response `200` `{ data?: ((QualificationAnswerLabel))[] }` get labels success
     */
    qualificationAnswerLabelsList: (
      query: QualificationAnswerLabelsListParams,
      params: RequestParams = {}
    ) =>
      this.request<{ data?: QualificationAnswerLabel[] }, any>({
        path: `/insights_platform/qualification-answer-labels`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags qualifications
     * @name QualificationsList
     * @summary Retrieves available qualifications by country and language
     * @request GET:/insights_platform/qualifications
     * @secure
     * @response `200` `{ data?: ((Qualification))[], included?: ((QualificationAnswer))[] }` profiling qualifications only
     */
    qualificationsList: (
      query: QualificationsListParams,
      params: RequestParams = {}
    ) =>
      this.request<
        { data?: Qualification[]; included?: QualificationAnswer[] },
        any
      >({
        path: `/insights_platform/qualifications`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags qualifications
     * @name QualificationsDetail
     * @summary Retrieves a qualification
     * @request GET:/insights_platform/qualifications/{id}
     * @secure
     * @response `200` `{ data?: Qualification, included?: ((QualificationAnswer))[] }` qualification found
     */
    qualificationsDetail: (
      id: string,
      byQuestionId: boolean,
      params: RequestParams = {}
    ) =>
      this.request<
        { data?: Qualification; included?: QualificationAnswer[] },
        any
      >({
        path: `/insights_platform/qualifications/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags tap_answers_list
     * @name TapQuestionsTapAnswersListDetail
     * @summary Retrieves all tap answers for a given tap question
     * @request GET:/insights_platform/tap_questions/{identifier}/tap-answers-list
     * @secure
     * @response `200` `{ data?: ((TapAnswer))[] }` authorized
     * @response `401` `void` unauthorized
     */
    tapQuestionsTapAnswersListDetail: (
      { identifier, ...query }: TapQuestionsTapAnswersListDetailParams,
      params: RequestParams = {}
    ) =>
      this.request<{ data?: TapAnswer[] }, void>({
        path: `/insights_platform/tap_questions/${identifier}/tap-answers-list`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags tap_question_cross_tab_result
     * @name TapQuestionsCrossTabResultsDetail
     * @summary Retrieves the single survey tap question cross tab result
     * @request GET:/insights_platform/tap_questions/{identifier}/cross-tab-results
     * @secure
     * @response `200` `{ data?: TapQuestionCrossTabResult }` authorized
     * @response `401` `void` unauthorized
     */
    tapQuestionsCrossTabResultsDetail: (
      { identifier, ...query }: TapQuestionsCrossTabResultsDetailParams,
      params: RequestParams = {}
    ) =>
      this.request<{ data?: TapQuestionCrossTabResult }, void>({
        path: `/insights_platform/tap_questions/${identifier}/cross-tab-results`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags tap_question_result
     * @name TapQuestionsResultsDetail
     * @summary Retrieves the single survey tap question result
     * @request GET:/insights_platform/tap_questions/{identifier}/results
     * @secure
     * @response `200` `{ data?: TapQuestionResult }` authorized
     * @response `401` `void` unauthorized
     */
    tapQuestionsResultsDetail: (
      { identifier, ...query }: TapQuestionsResultsDetailParams,
      params: RequestParams = {}
    ) =>
      this.request<{ data?: TapQuestionResult }, void>({
        path: `/insights_platform/tap_questions/${identifier}/results`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags tap_survey_questions_list
     * @name TapSurveysQuestionsListDetail
     * @summary Retrieves a list of questions
     * @request GET:/insights_platform/tap_surveys/{identifier}/questions-list
     * @secure
     * @response `200` `{ data?: ((TapQuestion))[] }` authorized
     * @response `401` `void` unauthorized
     */
    tapSurveysQuestionsListDetail: (
      { identifier, ...query }: TapSurveysQuestionsListDetailParams,
      params: RequestParams = {}
    ) =>
      this.request<{ data?: TapQuestion[] }, void>({
        path: `/insights_platform/tap_surveys/${identifier}/questions-list`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
}
